import { render } from "./RedirectingOverlay.vue?vue&type=template&id=05772405&scoped=true"
import script from "./RedirectingOverlay.vue?vue&type=script&lang=js"
export * from "./RedirectingOverlay.vue?vue&type=script&lang=js"

import "./RedirectingOverlay.vue?vue&type=style&index=0&id=05772405&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05772405"]])

export default __exports__